<template>
  <div class="list-page-container">
    <div class="breadcrumbs">备件服务</div>
    <div class="header-button">
      <el-button type="success" icon="el-icon-document-add" @click="addSpareParts()">新增</el-button>
    </div>
    <div class="list-page-wrap">
      <!-- 顶部操作栏 -->
      <div class="list-page-heaser">
        <el-form ref="searchForm" class="header-search" :model="searchData" @keydown.enter.native="searchSubmit">
          <el-form-item label="备件名称" prop="name">
            <el-input v-model="searchData.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="备件型号" prop="model">
            <el-input v-model="searchData.model" clearable></el-input>
          </el-form-item>
          <el-form-item label="备件类型" prop="type_id">
            <el-select v-model="searchData.type_id" placeholder="请选择">
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" icon="el-icon-search" @click="searchSubmit()">查询</el-button>
            <el-button @click="resetSearch()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 列表数据 -->
      <Product-overview-card :data="tableData" :pagination="pagination" @current-page-change="handleCurrentChange"
        @size-change="handleSizeChange" @edit-spareparts="handleEditSpareParts" @delete-spareparts="deleteListRow">
      </Product-overview-card>
    </div>
    <!-- 新增 -->
    <el-dialog :title="addSparePartsTitle" width="1000px" custom-class="near" :append-to-body="true"
      :close-on-click-modal="false" :visible.sync="addSparePartsVisible" @closed="closeAddProductDialog()">
      <el-form ref="addSparePartsForm" :rules="addSparePartsRules" :model="addSparePartsData" label-position="top">
        <el-row :gutter="16">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="备件名称" prop="name">
                <el-input v-model="addSparePartsData.name" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备件型号" prop="model">
                <el-input v-model="addSparePartsData.model" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备件类型" prop="type_id">
                <el-select v-model="addSparePartsData.type_id" placeholder="请选择">
                  <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品类型" prop="product_type_id">
                <el-select v-model="addSparePartsData.product_type_id" placeholder="请选择">
                  <el-option v-for="item in ProducttypeList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备件描述" prop="description">
                <el-input v-model="addSparePartsData.description" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="产品图片" prop="image_oss_id">
                <el-upload class="avatar-uploader" drag :show-file-list="false" :action="uploadUrl"
                  :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="安装视频" prop="video">
                <el-upload class="video-upload" :action="uploadUrl" :file-list="videoFileList"
                  :accept="'video/mp4,video/avi,video/mkv,video/quicktime'" :on-success="handleVideoSuccess"
                  :before-upload="beforeVideoUpload" :on-remove="handleVideoRemove">
                  <el-button size="small" type="success" icon="el-icon-upload2">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <!-- <el-col :span="12">
              <el-form-item label="价格" prop="price" >
                <el-input v-model="addSparePartsData.price" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存" prop="stock" >
                <el-input-number v-model="addSparePartsData.stock" clearable style="width: 100%;">
                </el-input-number>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item class="text-right">
                <el-button @click="addSparePartsVisible = false">取消</el-button>
                <el-button type="success" @click="addSparePartsSubmit()">保存</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/api'
import listMixin from '@/mixins/listMixin'
import * as DICT from '@/utils/dict/fieldDictionary'
import ProductOverviewCard from './spare-parts-card.vue'

export default {
  name: 'DeviceOverviewAata',
  mixins: [listMixin],
  components: {
    ProductOverviewCard
  },
  data() {
    return {
      dataDict: DICT,
      typeList: [],
      ProducttypeList: [],
      videoFileList: [],
      uploadUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_UPLOAD.url}?token=${localStorage.getItem('token')}`,
      imageUrl: '',
      // 列表相关数据
      searchData: {
        name: '',
        model: '',
        type_id: null
      },
      pagination: {
        currentPage: 1,
        pageSize: 6,
        total: 0
      },
      queryListApi: apis.QUERY_SPAREPARTS_LIST,
      deleteListParams: {
        api: apis.DELETE_SPAREPARTS,
        id: 'id'
      },
      addSparePartsTitle: '新增产品',
      addSparePartsVisible: false,
      addSparePartsData: {
        id: '',
        name: '',
        description: '',
        model: '',
        type_id: '',
        product_type_id: '',
        image_oss_id: '',
        video_url: '',
        price: '',
        stock: 0
      },
      addSparePartsRules: {
        name: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择产品类型', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.queryType()
    this.queryProductType()
  },
  methods: {
    closeAddProductDialog() {
      this.addSparePartsData = {
        id: '',
        name: '',
        description: '',
        model: '',
        type_id: '',
        product_type_id: '',
        image_oss_id: '',
        video_url: '',
        price: '',
        stock: 0
      }
      this.imageUrl = ''
      this.$nextTick(() => {
        this.$refs.addSparePartsForm.clearValidate()
      })
    },
    handleImageSuccess(res, file) {
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${res.data.id}`
      this.addSparePartsData.image_oss_id = res.data.id
    },
    beforeImageUpload(file) {
      const isImg = ['image/jpeg', 'image/png'].includes(file.type)

      if (!isImg) {
        this.$message.error('只能上传图片格式!')
      }
      return isImg
    },
    handleVideoSuccess(res, file, fileList) {
      console.log(res)
      this.addSparePartsData.video_url = res.data.id
      this.videoFileList = [file]
    },
    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/')
      if (!isVideo) {
        this.$message.error('请上传视频文件')
        return false
      }
      return true
    },
    handleVideoRemove(file, fileList) {
      console.log('删除图片：', file, fileList)
      this.addSparePartsData.video_url = this.addSparePartsData.video_url.filter(element => element.object_id !== file.uid)
      this.videoFileList = fileList
      console.log(this.addSparePartsData.video)
    },
    queryType() {
      this.typeList = []
      const request = {
        ...apis.QUERY_SPAREPARTS_TYPES
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.typeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    queryProductType() {
      this.ProducttypeList = []
      const request = {
        ...apis.QUERY_PRODUCT_TYPE
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (resp.rst === 200) {
              this.ProducttypeList = resp.data
            }
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error('额外错误处理:', err)
        })
    },
    addSpareParts() {
      this.addSparePartsTitle = '新增产品'
      this.addSparePartsVisible = true
    },
    handleEditSpareParts(item) {
      console.log('编辑-2')
      console.log(item)
      this.addSparePartsTitle = '编辑产品'
      this.addSparePartsVisible = true
      // 映射行数据到对话框表单，并自动选中对应状态按钮
      this.addSparePartsData = {
        id: item.id,
        name: item.name,
        description: item.description,
        model: item.model,
        type_id: item.type_id,
        product_type_id: item.product_type_id,
        image_oss_id: item.image_oss_id,
        video_url: item.video_url,
        price: item.price,
        stock: item.stock
      }
      this.imageUrl = `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}${item.image_oss_id}`
    },
    addSparePartsSubmit() {
      this.$refs.addSparePartsForm.validate((valid) => {
        if (!valid) {
          return false
        }
        let request = {}
        if (this.addSparePartsData.id) {
          request = {
            url: '/api/v1/admin/spare_parts/' + this.addSparePartsData.id,
            method: 'put',
            disableSuccessMsg: true,
            disableErrorMsg: false,
            params: {
              ...this.addSparePartsData
            }
          }
        } else {
          request = {
            ...apis.SAVE_SPAREPARTS,
            params: {
              ...this.addSparePartsData
            }
          }
        }
        this.$request(request)
          .asyncThen(
            (resp) => {
              if (resp.rst === 200) {
                this.queryListData()
                this.addSparePartsVisible = false
              }
            },
            (err) => {
              console.error(err)
            }
          )
          .asyncErrorCatch((err) => {
            console.error('额外错误处理:', err)
          })
      })
    }
  }
}
</script>

<style scoped>
.el-select {
  width: 100%;
}

.avatar-uploader .el-upload {
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.el-upload-dragger {
  width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  /* width: 178px;
    height: 178px;
  display: block;*/
  max-width: 100%;
  max-height: 100%;
}

/* 编辑器整体容器 */
.quill-editor {
  width: 100%;
  height: 200px !important;
}

::v-deep .ql-container {
  height: calc(100% - 42px);
  box-sizing: border-box !important;
}
</style>
